import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UpdateCheckService } from '../../../services/update-check.service';

/**
 * Persistent banner shown when a newer frontend has been deployed. Mounted in
 * both shells (admin-layout, portal-layout). Driven by UpdateCheckService.
 */
@Component({
  selector: 'app-update-banner',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  template: `
    @if (updateCheck.updateAvailable()) {
      <div class="update-banner" role="alert">
        <mat-icon class="update-banner__icon">system_update</mat-icon>
        <span class="update-banner__text">A new version of the application is available.</span>
        <button mat-flat-button color="primary" class="update-banner__btn" (click)="reload()">
          <mat-icon>refresh</mat-icon>
          Reload
        </button>
      </div>
    }
  `,
  styles: [`
    .update-banner {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 16px;
      background: #fff3cd;
      color: #664d03;
      border-bottom: 1px solid #ffe69c;
      font-size: 14px;
    }
    .update-banner__icon { flex: 0 0 auto; }
    .update-banner__text { flex: 1 1 auto; }
    .update-banner__btn { flex: 0 0 auto; }
  `]
})
export class UpdateBannerComponent {
  protected readonly updateCheck = inject(UpdateCheckService);

  protected reload(): void {
    window.location.reload();
  }
}
